<ion-grid>
  <ion-row>
    <ion-col size="2">
      <icon-wrapper [icon]="icon" [custom]="false"></icon-wrapper>
    </ion-col>
    <ion-col size="10">
      <ion-row>
        <span class="info-text-m bold text-color-primary">{{ leplaceId }}</span>
      </ion-row>
      <ion-row>
        <span class="info-text-s text-color-primary">{{ name }}</span>
      </ion-row>
      <ion-row>
        <span class="info-text-s text-color-alternate">{{ type }}</span>
      </ion-row>
    </ion-col>
  </ion-row>
</ion-grid>